(()=>{
  if(customElements.get('satgear-customer-logos'))return;
  class SatGearCustomerLogos extends HTMLElement{
    connectedCallback(){
      if(this.ready){this.media.forEach(m=>m.addEventListener('change',this.onResize));return;}
      const script=this.querySelector('[data-customer-data]');
      if(!script){this.queueLoad();return;}
      this.data=JSON.parse(script.textContent);
      this.byId=new Map(this.data.brands.map(r=>[r.id,r]));
      this.category='all';this.visible=this.initialSize();this.moreStep=1;this.mobileStep=1;this.expanded=false;this.ready=true;
      this.media=[matchMedia('(max-width: 640px)'),matchMedia('(max-width: 1023px)')];this.onResize=()=>{if(!this.expanded)this.visible=this.initialSize();this.updateIndustries();this.render();};this.media.forEach(m=>m.addEventListener('change',this.onResize));
      this.heading=this.querySelector('[data-heading]');this.grid=this.querySelector('[data-grid]');this.more=this.querySelector('[data-more]');this.less=this.querySelector('[data-less]');
      this.querySelectorAll('[data-category]').forEach(b=>{b.disabled=false;b.addEventListener('click',()=>this.select(b.dataset.category));});
      this.industryToggle=this.querySelector('[data-industries-toggle]');this.industryExpanded=false;
      if(this.industryToggle){
        this.industryToggle.disabled=false;
        this.industryToggle.addEventListener('click',()=>{this.industryExpanded=!this.industryExpanded;this.updateIndustries();if(!this.industryExpanded)this.industryToggle.scrollIntoView({block:'nearest',behavior:'auto'});});
        this.updateIndustries();
      }
      this.more.addEventListener('click',()=>{const firstNew=this.visible,batch=this.batchSize(),multiplier=matchMedia('(max-width: 640px)').matches?2**this.mobileStep++:batch===21?++this.moreStep:1;this.expanded=true;this.visible=Math.min(this.ids().length,this.visible+batch*multiplier);this.render();this.grid.children[firstNew]?.querySelector('figure')?.focus({preventScroll:true});});
      this.less.addEventListener('click',()=>{this.visible=this.initialSize();this.moreStep=1;this.mobileStep=1;this.expanded=false;this.render();this.querySelector('[data-category][aria-pressed=true]').focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
      this.more.disabled=false;this.dataset.ready='true';this.data.heading=this.heading.textContent;this.render();
    }
    disconnectedCallback(){this.media?.forEach(m=>m.removeEventListener('change',this.onResize));this.loadObserver?.disconnect();this.loadObserver=null;this.controller?.abort();}

    queueLoad(){
      if(this.loading||this.loadObserver||!this.dataset.source)return;
      if(typeof IntersectionObserver==='undefined'){this.loadData();return;}
      this.loadObserver=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)){
          this.loadObserver.disconnect();this.loadObserver=null;this.loadData();
        }
      },{rootMargin:'600px'});
      this.loadObserver.observe(this);
    }
    async loadData(){
      if(this.loading||!this.isConnected)return;
      this.loading=true;this.controller=new AbortController();
      const button=this.querySelector('[data-more]');
      button.disabled=true;
      try{
        const response=await fetch(this.dataset.source,{signal:this.controller.signal});
        if(!response.ok)throw new Error('Customer data unavailable');
        const data=await response.json();
        if(!this.isConnected)return;
        if(!Array.isArray(data.brands)||!Array.isArray(data.categories)||!Array.isArray(data.all))throw new Error('Customer data invalid');
        const script=document.createElement('script');
        script.type='application/json';script.dataset.customerData='';script.textContent=JSON.stringify(data);
        this.append(script);this.connectedCallback();
      }catch(error){
        if(error.name!=='AbortError'&&this.isConnected){
          button.disabled=false;button.addEventListener('click',()=>this.loadData(),{once:true});
        }
      }finally{this.loading=false;if(this.controller.signal.aborted&&this.isConnected&&!this.ready)this.queueLoad();}
    }
    mobileColumns(){return this.dataset.mobileColumns==='3'?3:2;}
    batchSize(){return matchMedia('(max-width: 640px)').matches?4*this.mobileColumns():matchMedia('(max-width: 1023px)').matches?12:21;}
    initialSize(){return matchMedia('(max-width: 640px)').matches?4*this.mobileColumns():this.batchSize();}
    updateIndustries(){
      if(!this.industryToggle)return;
      const mobile=matchMedia('(max-width: 640px)').matches,buttons=[...this.querySelectorAll('[data-category]')],initial=buttons.slice(0,6),selected=buttons.find(b=>b.dataset.category===this.category);
      const visible=new Set(initial.includes(selected)?initial:[...initial.slice(0,5),selected]);
      buttons.forEach(b=>{b.hidden=mobile&&!this.industryExpanded&&!visible.has(b);});
      this.industryToggle.setAttribute('aria-expanded',String(this.industryExpanded));
      this.industryToggle.querySelector('[data-industries-label]').textContent=this.industryExpanded?this.dataset.fewerIndustries:this.dataset.allIndustries;
    }
    ids(){
      if(this.category!=='all')return this.data.categories.find(c=>c.id===this.category).brands;
      const from=this.dataset.desktopFeaturedFrom,to=this.dataset.desktopFeaturedTo;
      if(!matchMedia('(min-width: 1024px)').matches||!from||!to||!this.data.all.includes(from)||!this.data.all.includes(to))return this.data.all;
      return this.data.all.map(id=>id===from?to:id===to?from:id);
    }
    select(category){
      const mobileTabs=this.industryToggle&&matchMedia('(max-width: 640px)').matches?this.querySelector('.sg-cl__tabs'):null;
      const tabsTop=mobileTabs?.getBoundingClientRect().top,wasExpanded=this.industryExpanded;
      this.industryExpanded=false;
      if(category===this.category){this.updateIndustries();this.restoreMobileTabsPosition(mobileTabs,wasExpanded?16:tabsTop);return;}
      this.category=category;this.visible=this.initialSize();this.moreStep=1;this.mobileStep=1;this.expanded=false;
      this.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
      const selected=this.querySelector('[data-category][aria-pressed=true]');
      if(matchMedia('(max-width: 640px)').matches&&!this.industryToggle&&!this.dataset.mobileLayout)selected.scrollIntoView({block:'nearest',inline:'center',behavior:'auto'});
      this.heading.textContent=category==='all'?this.data.heading:this.querySelector('[data-category][aria-pressed=true]').dataset.headline;
      this.render();
      this.updateIndustries();
      this.restoreMobileTabsPosition(mobileTabs,wasExpanded?16:tabsTop);
    }
    restoreMobileTabsPosition(tabs,targetTop){
      if(!tabs)return;
      // Keep the mobile controls in place; after closing the full list, show the controls and logos together.
      const delta=tabs.getBoundingClientRect().top-targetTop;
      if(Math.abs(delta)>1)window.scrollBy({top:delta,left:0,behavior:'instant'});
    }
    render(){
      const ids=this.ids(),shown=ids.slice(0,this.visible),fragment=document.createDocumentFragment();
      for(const id of shown){
        const r=this.byId.get(id),li=document.createElement('li'),figure=document.createElement('figure'),art=document.createElement('div'),img=document.createElement('img'),caption=document.createElement('figcaption');
        figure.className='sg-cl__card';figure.tabIndex=-1;figure.dataset.brand=id;
        art.className='sg-cl__art'+(r.dark?' sg-cl__art--dark':'');
        img.loading='lazy';img.decoding='async';img.alt='';img.width=r.width;img.height=r.height;img.sizes="(max-width: 640px) calc((100vw - 102px) / 3), (max-width: 1023px) calc((100vw - 226px) / 4), (max-width: 1335px) calc((100vw - 388px) / 7), 136px";const widths=[180,320,480,600].filter(width=>width<r.width).concat(r.width),separator=r.image.includes('?')?'&':'?';img.srcset=widths.map(width=>r.image+separator+'width='+width+' '+width+'w').join(', ');img.src=r.image+separator+'width='+Math.min(480,r.width);
        caption.textContent=r.name;art.append(img);figure.append(art,caption);li.append(figure);fragment.append(li);
      }
      this.grid.replaceChildren(fragment);
      this.more.hidden=shown.length>=ids.length;this.less.hidden=shown.length<=this.initialSize();
    }
  }
  customElements.define('satgear-customer-logos',SatGearCustomerLogos);
})();
